module.exports = __webpack_public_path__ + "img/honor_1.bd36ad0f.png";